import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { Messages } from 'primereact/messages';

interface AlterMessageProps {
    className?: string | undefined;
    type: 'error' | 'success' | 'secondary' | 'info' | 'contrast' | 'warn';
    title?: string;
    allowHtml?: boolean;
    closable?: boolean;
}

export const AlertMessage: React.FC<AlterMessageProps & PropsWithChildren> = (props) => {
    const msgs = useRef<Messages>(null);

    useEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                {
                    severity: props.type,

                    // detail: ()props.children,
                    detail: (
                        <div>
                            {(props.title) && (<div className="font-bold mb-1">{props.title}</div>)}
                            <div>{props.children}</div>
                        </div>
                    ),
                    sticky: true,
                    closable: (props.closable === undefined) ? false: props.closable,
                }
            ]);
        }
    }, [msgs.current, props.title, props.children]);

    return (
        <Messages ref={msgs} className={props.className}/>
    )
};

